import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import type { ReactNode } from "react";
import { useCanvasToolbarLayoutOptional } from "../../context/CanvasToolbarLayoutContext";
import { CANVAS_TOOLBAR_SUBMENU_GAP_PX } from "./canvasToolbarLayout.constants";
import { CanvasToolbarShell } from "./CanvasToolbarShell";

interface CanvasToolbarSubmenuProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trigger: ReactNode;
  /** Which side the submenu opens toward. Defaults from toolbar layout context. */
  side?: "top" | "bottom" | "left" | "right";
  sideOffset?: number;
  children: ReactNode;
}

/**
 * Type-1 horizontal submenu — same shell chrome as the parent toolbar.
 */
export function CanvasToolbarSubmenu({
  open,
  onOpenChange,
  trigger,
  side,
  sideOffset,
  children,
}: CanvasToolbarSubmenuProps) {
  const layout = useCanvasToolbarLayoutOptional();
  const resolvedSide = side ?? layout?.menuSide ?? "bottom";
  const resolvedSideOffset =
    sideOffset ?? layout?.submenuGapPx ?? CANVAS_TOOLBAR_SUBMENU_GAP_PX;

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent
        className="w-auto border-0 bg-transparent p-0 shadow-none"
        align="center"
        side={resolvedSide}
        sideOffset={resolvedSideOffset}
        onPointerDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <CanvasToolbarShell className="max-w-none">
          {children}
        </CanvasToolbarShell>
      </PopoverContent>
    </Popover>
  );
}
